import ServiceCard from '@/components/ServiceCard'

const courseCategories = [
  {
    title: 'Cuidado de Mascotas',
    icon: 'ph ph-paw-print',
    courses: [
      'Cuidado de mascotas',
      'Cuidado básico de perros',
      'Cuidado básico de gatos',
      'Tenencia responsable de mascotas',
      'Alimentación básica para mascotas',
      'Higiene de las mascotas',
      'Calendario de vacunación',
      'Desparasitación de mascotas',
      'Cuidados del cachorro',
      'Cuidados del gato',
      'Cuidados de mascotas adultas',
    ],
  },
  {
    title: 'Salud Animal',
    icon: 'ph ph-heartbeat',
    courses: [
      'Salud animal',
      'Prevención de enfermedades comunes',
      'Cómo detectar signos de enfermedad',
      'Primeros auxilios básicos para mascotas',
      'Cuidados después de una cirugía',
      'Manejo de mascotas enfermas',
      'Manejo de mascotas mayores',
    ],
  },
  {
    title: 'Manipulación de Alimentos',
    icon: 'ph ph-spray-bottle',
    courses: [
      'Manipulación de alimentos',
      'Manipulación segura de alimentos',
      'Higiene alimentaria',
      'Buenas prácticas de higiene',
      'Prevención de contaminación de alimentos',
      'Conservación correcta de alimentos',
      'Cadena de frío',
      'Limpieza y desinfección en cocinas',
      'Seguridad alimentaria básica',
    ],
  },
  {
    title: 'Producción Animal',
    icon: 'ph ph-cow',
    courses: [
      'Producción animal',
      'Cuidado básico del ganado',
      'Manejo básico de bovinos',
      'Manejo básico de equinos',
      'Manejo básico de ovinos',
      'Manejo básico de caprinos',
      'Manejo básico de porcinos',
      'Cuidado de aves de corral',
      'Alimentación básica de animales de granja',
    ],
  },
  {
    title: 'Bienestar Animal',
    icon: 'ph ph-hand-heart',
    courses: [
      'Bienestar animal',
      'Manejo responsable de animales',
      'Prevención del maltrato animal',
      'Cuidados diarios de los animales',
      'Educación para dueños',
    ],
  },
  {
    title: 'Educación para Dueños',
    icon: 'ph ph-chalkboard-teacher',
    courses: [
      'Cómo elegir una mascota',
      'Preparación del hogar para una mascota',
      'Convivencia entre niños y mascotas',
      'Viajar con mascotas',
      'Cuidados durante el verano',
      'Cuidados durante el invierno',
    ],
  },
  {
    title: 'Higiene y Prevención',
    icon: 'ph ph-shield-check',
    courses: [
      'Control de pulgas y garrapatas',
      'Prevención de parásitos',
      'Limpieza del entorno de las mascotas',
      'Higiene en establecimientos con animales',
    ],
  },
  {
    title: 'Comunidad y Educación',
    icon: 'ph ph-users',
    courses: [
      'Prevención de zoonosis',
      'Animales y salud pública',
      'Educación ambiental',
      'Cuidado responsable de animales en la comunidad',
    ],
  },
]

function Cursos() {
  return (
    <div className="relative min-h-screen bg-background">
      <div className="watermark" aria-hidden="true"></div>
      <section className="page-hero h-64 md:h-80 flex items-center justify-center">
        <img
          src="/Docs/Fotos/Horcon foto.png"
          alt="Veterinario con material educativo"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary/60"></div>
        <h1 className="relative text-3xl md:text-4xl font-bold text-white">Cursos</h1>
      </section>

      <section className="py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {courseCategories.map((category, categoryIndex) => (
            <div key={category.title} className="mb-12 last:mb-0">
              <h2 className="text-2xl font-bold text-text-primary mb-6 flex items-center">
                <i className={`${category.icon} text-2xl text-primary mr-3`}></i>
                {category.title}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {category.courses.map((course, index) => (
                  <ServiceCard
                    key={course}
                    title={course}
                    icon="ph ph-graduation-cap"
                    href="/contacto"
                    index={categoryIndex * 100 + index}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Cursos